<div class="user-cards-container">
  <div class="cards-grid">
    <div class="card" *ngFor="let card of cards">
      <div class="card-header">
        <img [src]="card.image" [alt]="card.title" class="card-image" />
        <div class="card-info">
          <h3 class="card-title">{{ card.title }}</h3>
          <p class="card-description">{{ card.description }}</p>
        </div>
      </div>
      <div class="card-action">
        <div class="button-wrapper" *ngIf="card.hasDropdown; else simpleButton">
          <button
            class="card-button dropdown-toggle"
            (click)="toggleDropdown()"
            [attr.aria-expanded]="dropdownOpen"
          >
            {{ card.buttonText }}
          </button>
          <ul class="dropdown-menu" [class.show]="dropdownOpen">
            <li *ngFor="let item of card.dropdownItems" class="dropdown-item">
              <a [href]="item.link" class="dropdown-link">{{ item.label }}</a>
            </li>
          </ul>
        </div>
        <ng-template #simpleButton>
          <a
            [href]="card.buttonLink"
            class="card-button"
            [target]="card.title === 'Achieve' ? '_blank' : '_self'"
          >
            {{ card.buttonText }}
          </a>
        </ng-template>
      </div>
    </div>
  </div>
</div>
